import { useEffect, useRef } from "react";

// ============================================================================
// CONFETTI BURST — dependency-free canvas animation, ~2 seconds
// ============================================================================
export default function ConfettiBurst({ onDone }) {
  const canvasRef = useRef(null);
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    const W = (canvas.width = window.innerWidth);
    const H = (canvas.height = window.innerHeight);
    const COLORS = ["#0073ea", "#00c875", "#fdab3d", "#e2445c", "#a25ddc", "#ffcb00"];
    const N = 140;
    const pieces = Array.from({ length: N }, () => ({
      x: W / 2 + (Math.random() - 0.5) * 200,
      y: -20 - Math.random() * 60,
      vx: (Math.random() - 0.5) * 6,
      vy: 2 + Math.random() * 3,
      size: 6 + Math.random() * 6,
      rot: Math.random() * Math.PI * 2,
      vr: (Math.random() - 0.5) * 0.3,
      color: COLORS[Math.floor(Math.random() * COLORS.length)],
    }));
    let raf;
    let start = null;
    const DURATION_MS = 2200;
    let finished = false;
    const tick = (ts) => {
      if (start === null) start = ts;
      const elapsed = ts - start;
      ctx.clearRect(0, 0, W, H);
      for (const p of pieces) {
        p.x += p.vx;
        p.y += p.vy;
        p.vy += 0.08;
        p.rot += p.vr;
        ctx.save();
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rot);
        ctx.fillStyle = p.color;
        ctx.fillRect(-p.size / 2, -p.size / 2, p.size, p.size * 0.6);
        ctx.restore();
      }
      if (elapsed < DURATION_MS) {
        raf = requestAnimationFrame(tick);
      } else if (!finished) {
        finished = true;
        ctx.clearRect(0, 0, W, H);
        // Ask the parent to unmount us so we don't leave a stray full-screen
        // canvas at zIndex 9999 covering the page.
        if (onDone) onDone();
      }
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [onDone]);

  return (
    <canvas
      ref={canvasRef}
      style={{
        position: "fixed",
        inset: 0,
        pointerEvents: "none",
        zIndex: 9999,
      }}
    />
  );
}
